import { useEffect, useId, useRef } from "react";
import { defineStrings, useStrings } from "../i18n";
import { Icon } from "./Icon";

const strings = defineStrings(
  { continue: "Keep going", kicker: "Milestone" },
  { continue: "On continue", kicker: "Étape franchie" },
);

/**
 * The celebration moment: shown when the engine reports a milestone (a skill crossing its
 * mastered threshold, a review streak). The app decides *when* only from engine events;
 * the copy is short and about effort ("You worked hard on fractions"), never a score.
 * No timer: it stays until the child continues (WCAG 2.2.1). With reduced motion the
 * stars are still; otherwise they rise once, gently.
 */
export function Celebration(props: { title: string; message: string; onContinue: () => void }) {
  const t = useStrings(strings);
  const button = useRef<HTMLButtonElement>(null);
  const titleId = useId();
  useEffect(() => {
    button.current?.focus();
  }, []);
  return (
    <div className="ui-celebration" role="dialog" aria-modal="false" aria-labelledby={titleId}>
      <div className="ui-celebration__stars" aria-hidden="true">
        {Array.from({ length: 7 }, (_, i) => (
          <span key={i} className="ui-celebration__star">
            <Icon name={i % 2 === 0 ? "star" : "sparkle"} size={i % 3 === 0 ? 34 : 24} />
          </span>
        ))}
      </div>
      <p className="ui-celebration__kicker">{t("kicker")}</p>
      <h2 id={titleId} className="ui-celebration__title">
        {props.title}
      </h2>
      <p className="ui-celebration__message">{props.message}</p>
      <button
        ref={button}
        type="button"
        className="ui-button ui-button--primary ui-button--big"
        onClick={props.onContinue}
      >
        <span className="ui-button__label">{t("continue")}</span>
      </button>
    </div>
  );
}
